<template>
  <!-- Default Template       **************************** -->
  <div id="primer-content" v-show="slide.template == 'default' || slide.template == ''">
    <v-card class="lessoncard" style="height: 100%" elevation="0">
      <v-card-title class="justify-center">
        <h1 v-if="slide.pageTitle">
          {{ slide.pageTitle }}
        </h1>
      </v-card-title>

      <p id="text" style="margin-top: 50px; font-size: 16pt !important">
        {{ slide.textArea }}
      </p>
      <p
        id="text"
        style="margin-top: 50px; font-size: 16pt !important"
        v-if="slide.bodyText && slide.displayMode !== 'imageDeck'"
        v-html="slide.bodyText"
      ></p>

      <div
        v-if="
          (slide.displayMode === 'both' || slide.displayMode === 'imageDeck') &&
          slide.img
        "
      >
        <div v-for="(image, i) in slide.img" :key="i" class="image-margin">
          <div v-bind:class="{ 'loading': !isLoaded }">
            <v-img
              v-show="isLoaded"
              @click="imgClick(image)"
              style="cursor: pointer"
              @load="onImgLoad"
              max-height="55vh"
              contain
              :src="
                $store.state.primerImages.find((o) => o.name === image.file).url
              "
            />
          </div>
          <div v-if="image.show" @close="image.show = false">
            <div slot="body">
              <img :src="image.thumbnail" :class="`img-index--${i}`" />
            </div>
          </div>

          <h3
            v-if="slide.caption"
            id="text"
            class="caption"
            style="text-align: center"
          >
            {{ slide.caption[i] }}
          </h3>
        </div>
      </div>

      <div
        v-if="
          (slide.displayMode === 'both' || slide.displayMode === 'richText') &&
          slide.richText
        "
      >
        <div v-for="(entry, j) in slide.richText" :key="j" class="image-margin">
          <div v-bind:class="{ 'loading': !isLoaded }">
            <v-img
              v-show="isLoaded"
              v-if="entry.image"
              @load="onImgLoad"
              :src="getImageSrc(entry.image[0])"
            />
          </div>
          <h3
            class="caption"
            style="font-size: 12pt !important"
            v-show="entry.richText"
            v-html="entry.richText"
          ></h3>
        </div>
      </div>
    </v-card>
    <!-- <image-modal
        :showModal="showModal"
        :card="activeCard"
        v-on:close-modal="closeModal()"
      ></image-modal> -->
  </div>
</template>

<script>
import ImageModal from "./ImageModal.vue";
export default {
  components: { "image-modal": ImageModal },
  props: ["slide"],
  data() {
    return {
      imgsrc: "",
      btntext: "Show Image",
      isLoaded: false,
      showModal: false,
      activeCard: { fullBody: "" },
    };
  },
  mounted(){
    const paragraphs = document.getElementById('primer-content');
    var links = paragraphs.getElementsByTagName("a");
    for (var i=0; i<links.length; i++){
      links[i].setAttribute('target', '_blank');
    }
  },
  methods: {
    imgClick(item) {
      item.show = true;
      this.openModal();
    },
    getImageSrc(img) {
      var imgurl = "";
      if (img && this.slide.img.length) {
        imgurl = this.$store.state.primerImages.find(
          (o) => o.name === this.slide.img.find((x) => x.id === img).file
        ).url;
      }
      return imgurl;
    },
    onImgLoad() {
      this.isLoaded = true;
    },
    openModal(index) {
      this.showModal = true;
      console.log("show modal");
    },
    closeModal() {
      this.showModal = false;
      console.log("close modal");
    },
  },
};
</script>
<style scoped>
.v-card__text {
  font-size: 16pt !important;
}
#text >>> * {
  font-size: 16pt !important;
}
h1 {
  text-align: center;
  color: #415370;
}
.caption {
  color: #776c6c;
  padding: 10px;
  text-align: center;
  font-size: 12pt !important;
}
.caption span >>> * {
  color: #776c6c;
}
.lessoncard {
  max-width: 80%;
  margin: auto;
}
.loading {
  height: 200px;
  width: 200px;
  margin: auto;
  background: transparent
    url("https://miro.medium.com/max/882/1*9EBHIOzhE1XfMYoKz1JcsQ.gif") center
    no-repeat;
}
.image-margin {
  margin: 25px 0;
}
</style>
<style>
a[target="_blank"]::after {
  content: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAQElEQVR42qXKwQkAIAxDUUdxtO6/RBQkQZvSi8I/pL4BoGw/XPkh4XigPmsUgh0626AjRsgxHTkUThsG2T/sIlzdTsp52kSS1wAAAABJRU5ErkJggg==) !important;
  margin: 0 3px 0 5px;
}
</style>
